import React from 'react';

interface TableFromFileProps {
  filePath: string;
}

interface TableFromFileState {
  rows: JSX.Element[][];
}

class TableFromFile extends React.Component<TableFromFileProps, TableFromFileState> {
  private filePath: string;

  constructor(props: TableFromFileProps) {
    super(props);
    this.filePath = props.filePath;
    this.state = {
      rows: [],
    };
  }

  componentDidMount() {
    fetch(this.filePath)
      .then(res => res.text())
      .then(txt => {
        let fetchedRows = this.parseCsvFile(txt, '\t');
        this.setState({ rows: fetchedRows });
      });
  }

  parseCsvFile(file: string, separator: string): JSX.Element[][] {
    let lines = file.split('\n');
    let rows: JSX.Element[][] = [];
    for (let x = 1; x < lines.length; x++) {
      if (lines[x] != null && lines[x] != '') {
        let htmlLine: JSX.Element[] = [];
        lines[x].split(separator).map((value, i) => {
          htmlLine.push(<td key={i}>{value}</td>);
        });
        rows.push(htmlLine);
      }
    }
    return rows;
  }
  
  render() {
    return (
      <>
        {this.state.rows.map((line, i) => (
          <tr key={i}>{line}</tr>
        ))}
      </>
    );
  }
}

export { TableFromFile };
